export const translations = {
  hu: {
    locale: "hu",
    localeLabel: "Magyar",
    nav: {
      contact: "Kapcsolatfelvétel",
    },
    hero: {
      badge: "Szabadúszó webdesigner · Magyarország",
      headlineStart: "Modern weboldal az Ön",
      headlineHighlight: "vállalkozásának",
      headlineEnd: "- gyorsan és elérhető áron.",
      description:
        "Egyedi tervezésű weboldalak és webshopok, amelyek hitelesen képviselik vállalkozását – kiemelkedő designnal és okos AI-megoldásokkal.",
      ctaPrimary: "Kapcsolatfelvétel",
      ctaSecondary: "Szolgáltatások",
      stats: [
        { v: "100%", l: "Egyedi design" },
        { v: "24/7", l: "AI támogatás" },
      ],
      scrollHint: "Görgessen",
    },
    about: {
      label: "— Rólam",
      headingStart: "Egy weboldal valódi",
      headingItalic: "értéket",
      headingEnd: "teremt.",
      paragraphs: [
        "Weboldal designerként hiszek abban, hogy egy jól megépített weboldal valódi értéket teremt egy vállalkozás számára.",
        "Minden projektet a legnagyobb odafigyeléssel és szakmai tudással viszek végig – az Ön sikere az én sikerem is.",
      ],
      name: "Nagy Sándor",
      role: "Webdesigner · Alapító",
      badgeTitle: "✦ Egyedi",
      badgeSubtitle: "Nem sablon",
      photoCaption: "Webdesigner",
      established: "Est. 2024",
    },
    services: {
      label: "— Szolgáltatások",
      headingStart: "Amit",
      headingItalic: "kínálok.",
      more: "Tovább",
      items: [
        {
          title: "Weboldal készítés",
          text: "Letisztult, modern weboldal, amely hitelesen képviseli vállalkozását. Gyors betöltés, mobilbarát megjelenés és olyan design, amely az első pillanatban bizalmat épít látogatóiban.",
        },
        {
          title: "Webshop készítés",
          text: "Teljes körű online áruház kialakítása a termékkezeléstől a biztonságos fizetésig. Olyan webshopot kap, amely könnyen kezelhető, és valódi vásárlókat hoz weboldalára.",
        },
        {
          title: "Mesterséges intelligencia integráció",
          text: "Okos AI-asszisztens beépítése weboldalába, amely automatizálja a foglalásokat, árajánlat-kéréseket és űrlapbeküldéseket — így ügyfelei 0–24 órában kapcsolatba léphetnek Önnel, Ön pedig időt spórol.",
        },
        {
          title: "Weboldal karbantartás",
          text: "Folyamatos támogatás elkészült weboldala életében: új tartalmak feltöltése, frissítések, módosítások — hogy weboldala mindig naprakész és aktuális maradjon, anélkül, hogy Önnek kellene foglalkoznia a technikai részletekkel.",
        },
      ],
    },
    whyMe: {
      label: "— Miért engem",
      headingStart: "Néhány",
      headingItalic: "ok",
      headingEnd: ", amiért érdemes együtt dolgoznunk.",
      items: [
        {
          title: "Naprakész, modern megoldások",
          text: "Folyamatosan követem a legújabb technológiai trendeket, így olyan weboldalt kap, amely lépést tart a jelennel – nem egy elavult sablonnal.",
        },
        {
          title: "Egyedi, formabontó design",
          text: "Nem gyártok sablonokat. Minden weboldalt egyedileg alkotok meg, hogy vállalkozása valóban kitűnjön a versenytársak közül.",
        },
        {
          title: "Megbízhatóság és stabilitás",
          text: "Számomra a legfontosabb, hogy egy stabil, jól működő weboldalt kapjon – megfizethető áron, amire hosszú távon is építhet.",
        },
        {
          title: "Egyenlő figyelem minden ügyfélnek",
          text: "Akár egy egyszerű, akár egy komplex weboldalra van szüksége, minden megbízást azonos odafigyeléssel és szakmai elkötelezettséggel kezelek.",
        },
      ],
    },
    portfolio: {
      label: "— Portfólió",
      headingStart: "Néhány korábbi",
      headingItalic: "munkám.",
      projectTag: "Projekt",
      viewLabel: "Megtekintés",
      items: [
        {
          name: "Czudar Péter Szobafestő",
          desc: "Bemutatkozó weboldal érdi szobafestő mester számára helyszíni felmérés és ajánlatkérés funkciókkal.",
          quote: "„Sándor pontosan azt értette, amit elképzeltem – másfél hét alatt élesben volt az új oldalam, azóta sokkal több ajánlatkérést kapok.”",
          author: "Czudar Péter",
          role: "Szobafestő mester · Érd",
        },
        {
          name: "Black Car Service",
          desc: "Cegléd egyik legjobb autószervízének modern, sötét tónusú márka-weboldala időpontfoglalással.",
          quote: "„Profi munka, gyors reakcióidő és pont olyan határozott megjelenést kaptunk, amilyet a márkánkhoz akartunk.”",
          author: "Black Car Service",
          role: "Tulajdonos · Cegléd",
        },
        {
          name: "Gazsó-Pádár Papír-írószer",
          desc: "Helyi papír-írószer bolt bemutatkozó oldala termékkategóriákkal és nyitvatartással Budapest 17. kerületében.",
          quote: "„Végre van egy oldalunk, amit a vásárlók is megtalálnak Google-on – látszik a forgalmon a különbség.”",
          author: "Gazsó-Pádár",
          role: "Üzletvezető · Budapest",
        },
      ],
    },
    contact: {
      label: "— Kapcsolat",
      headingStart: "Beszéljünk a következő",
      headingItalic: "projektjéről.",
      description:
        "Bármilyen kérdéssel keressen bizalommal – általában 24 órán belül válaszolok.",
      phoneLabel: "Telefon",
      emailLabel: "Email",
      availability: "Jelenleg nyitott vagyok új projektek fogadására",
    },
    footer: {
      tagline: "Egyedi weboldalak és webshopok magyar vállalkozások számára.",
      contactLabel: "Elérhetőség",
      navLabel: "Navigáció",
      links: {
        about: "Rólam",
        services: "Szolgáltatások",
        portfolio: "Portfólió",
        contact: "Kapcsolat",
      },
      copyright: "© 2026 Nagy Sándor Web. Minden jog fenntartva.",
      credit: "Design és fejlesztés: Nagy Sándor",
    },
  },

  en: {
    locale: "en",
    localeLabel: "English",
    nav: {
      contact: "Get in touch",
    },
    hero: {
      badge: "Freelance web designer · Hungary",
      headlineStart: "A modern website for your",
      headlineHighlight: "business",
      headlineEnd: "– delivered fast and affordably.",
      description:
        "Custom-designed websites and online stores that authentically represent your business — backed by outstanding design and smart AI solutions.",
      ctaPrimary: "Get in touch",
      ctaSecondary: "Services",
      stats: [
        { v: "100%", l: "Custom design" },
        { v: "24/7", l: "AI assistance" },
      ],
      scrollHint: "Scroll",
    },
    about: {
      label: "— About",
      headingStart: "A website creates",
      headingItalic: "real value.",
      headingEnd: "",
      paragraphs: [
        "As a web designer, I believe that a well-built website creates real value for any business.",
        "I see every project through with the utmost care and craftsmanship — your success is my success.",
      ],
      name: "Sándor Nagy",
      role: "Web Designer · Founder",
      badgeTitle: "✦ Bespoke",
      badgeSubtitle: "Never a template",
      photoCaption: "Web Designer",
      established: "Est. 2024",
    },
    services: {
      label: "— Services",
      headingStart: "What I",
      headingItalic: "offer.",
      more: "Learn more",
      items: [
        {
          title: "Website design",
          text: "A clean, modern website that authentically represents your business. Fast loading, mobile-friendly, with a design that builds trust the moment visitors land.",
        },
        {
          title: "Online store",
          text: "A complete e-commerce build — from product management to secure payments. You get a store that's easy to manage and turns visitors into real customers.",
        },
        {
          title: "AI integration",
          text: "A smart AI assistant built into your site that automates bookings, quote requests and form submissions — so your customers can reach you 24/7 while you save time.",
        },
        {
          title: "Website maintenance",
          text: "Ongoing support for your finished website: content updates, fixes and tweaks — so your site stays current without you needing to handle the technical details.",
        },
      ],
    },
    whyMe: {
      label: "— Why me",
      headingStart: "A few",
      headingItalic: "reasons",
      headingEnd: " why it's worth working together.",
      items: [
        {
          title: "Modern, up-to-date solutions",
          text: "I follow the latest technology trends so you get a website that keeps pace with the present — not an outdated template.",
        },
        {
          title: "Distinctive, bespoke design",
          text: "I don't churn out templates. Every site is crafted individually so your business truly stands out from competitors.",
        },
        {
          title: "Reliability and stability",
          text: "What matters most to me is that you get a stable, well-functioning website at a fair price — something you can build on long term.",
        },
        {
          title: "Equal care for every client",
          text: "Whether you need a simple site or a complex one, every project gets the same attention and professional commitment.",
        },
      ],
    },
    portfolio: {
      label: "— Portfolio",
      headingStart: "Some of my",
      headingItalic: "recent work.",
      projectTag: "Project",
      viewLabel: "View",
      items: [
        {
          name: "Czudar Péter Painter",
          desc: "Brand site for a master painter based in Érd, with on-site survey requests and quote forms.",
          quote: "“Sándor understood exactly what I had in mind — my new site went live in under two weeks and I've been getting noticeably more quote requests ever since.”",
          author: "Péter Czudar",
          role: "Master painter · Érd",
        },
        {
          name: "Black Car Service",
          desc: "A modern, dark-toned brand site for one of Cegléd's best auto repair shops, with online appointment booking.",
          quote: "“Solid work, fast response times and exactly the confident look we wanted for our brand.”",
          author: "Black Car Service",
          role: "Owner · Cegléd",
        },
        {
          name: "Gazsó-Pádár Stationery",
          desc: "A local stationery store presentation site with product categories and opening hours in Budapest's 17th district.",
          quote: "“Customers can finally find us on Google — you can really feel the difference in foot traffic.”",
          author: "Gazsó-Pádár",
          role: "Store manager · Budapest",
        },
      ],
    },
    contact: {
      label: "— Contact",
      headingStart: "Let's talk about your next",
      headingItalic: "project.",
      description:
        "Reach out with any question — I usually reply within 24 hours.",
      phoneLabel: "Phone",
      emailLabel: "Email",
      availability: "Currently accepting new projects",
    },
    footer: {
      tagline: "Custom websites and online stores for Hungarian businesses.",
      contactLabel: "Contact",
      navLabel: "Navigation",
      links: {
        about: "About",
        services: "Services",
        portfolio: "Portfolio",
        contact: "Contact",
      },
      copyright: "© 2026 Nagy Sándor Web. All rights reserved.",
      credit: "Design & development: Sándor Nagy",
    },
  },
};
